export default [
  {
    path: '/attachments/:categoryId?',
    name: 'attachments#index',
    component: () => import('@views/attachments/index'),
    meta: {
      masteryHeader: true,
      header: true,
    },
  },
  {
    path: '/attachments/:categoryId/:attachmentId',
    name: 'attachments#show',
    component: () => import('@views/attachments/show'),
    meta: {
      masteryHeader: true,
      footer: true,
    },
  },
];
